import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/googleAnalytics";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
